import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6db9877c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vsetting" }
const _hoisted_2 = { class: "vtitle" }
const _hoisted_3 = { class: "v-content" }
const _hoisted_4 = { class: "lang" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "vers" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onMousedown"]
const _hoisted_9 = {
  key: 0,
  class: "gou icon i-duigou"
}

import bible, { State } from '@/store/bible/detail';
import search from '@/store/bible/search';
import { computed, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18'
interface BibleLang {
    lang: string,
    versions: Array<{
        label: string,
        key: string,
    }>
}

export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit: emits }: { emit: ({
    (e: 'close'): void,
}), expose: any, slots: any, attrs: any }) {

const store = useStore()

const i18Data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18Data.value.texts[i18Data.value.lang.list[i18Data.value.lang.now]].bible)

const data = computed<State>(() => store.state[bible.name])
const langs = computed<BibleLang[]>(() => store.getters[search.key('versions')])
const current = ref()
const temp = reactive({
    multi: false,
})


onMounted(() => {
    temp.multi = data.value.vers.length > 1
    if (data.value.vers.length > 0) {
        current.value = langs.value.find(item => item.versions.some(item0 => item0.key == data.value.vers[0]))
    } else {
        current.value = langs.value[0]
    }
})

function onLang(item: BibleLang) {
    current.value = item
}

function onVersion(key: string) {
    if (temp.multi) {
        let vers = data.value.vers.slice()
        let i = vers.indexOf(key)
        if (i == -1) {
            vers.push(key)
            bible.setVersions(store, vers)
        } else {
            if (vers.length > 1) {
                vers.splice(i, 1)
                bible.setVersions(store, vers)
            }
        }
    } else {
        bible.setVersions(store, [key])
    }
}

function onMultiChanged() {
    if (!temp.multi && data.value.vers.length > 1) {
        bible.setVersions(store, [data.value.vers[0]])
    }
}

function onCancel() {
    emits('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "close icon i-guanbi c-thirdary",
      onClick: onCancel
    }),
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_unref(lang).version_placeholder) + "： ", 1),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(temp).multi) = $event)),
          onChange: onMultiChanged
        }, null, 544), [
          [_vModelCheckbox, _unref(temp).multi]
        ]),
        _createTextVNode(_toDisplayString(_unref(lang).version_multi), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(langs), (item) => {
          return (_openBlock(), _createElementBlock("a", {
            class: _normalizeClass({ on: current.value && current.value.lang == item.lang }),
            onClick: ($event: any) => (onLang(item))
          }, _toDisplayString(item.lang), 11, _hoisted_5))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (current.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(current.value.versions, (item, i) => {
                return (_openBlock(), _createElementBlock("a", {
                  onMousedown: ($event: any) => (onVersion(item.key))
                }, [
                  _createTextVNode(_toDisplayString(item.label) + " ", 1),
                  (_unref(data).vers.indexOf(item.key) >= 0)
                    ? (_openBlock(), _createElementBlock("b", _hoisted_9))
                    : _createCommentVNode("", true)
                ], 40, _hoisted_8))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})